import { ModuleAccessGuard } from '@/components/ModuleAccessGuard';

export default function Storage() {
  return (
    <ModuleAccessGuard moduleId="storage">
      <div className="space-y-8">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Enhanced Storage</h1>
          <p className="text-muted-foreground mt-2">
            Increased storage limits and retention policies.
          </p>
        </div>
        <div className="text-center text-muted-foreground">
          Storage management interface coming soon.
        </div>
      </div>
    </ModuleAccessGuard>
  );
}